import React, { useState } from 'react'
import ActiveLoansTable from './Components/ActiveLoansTable';
import { LoansCardData } from './Components/LoansCardData';

const Loans = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div>
            {/* x---------------------------------x Loans Card Overview section x---------------------------------x */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" >
                {
                    LoansCardData.map((data, index) => (
                        <div key={index}>
                            <div className="card border-0 bg-transparent h-full">
                                <div className="card-body rounded-2xl bg-white p-4">
                                    <div className="flex items-center">
                                        <div
                                            className={`card-img w-16 h-16 rounded-full mr-4 flex items-center justify-center ${data.icon_bg}`}
                                        >
                                            {data.icon}
                                        </div>
                                        <div className="card-text">
                                            <p className="text-dark opacity-50 m-0">{data.title}</p>
                                            <p className="text-dark font-semibold m-0">{data.amount}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>

            {/* x---------------------------------x Active Loans Overview section x---------------------------------x */}
            <div className="grid grid-cols-1 my-2" >
                <div className="card border-0 bg-transparent h-100" >
                    <div className="card-header justify-content-between">
                        <h3 className="text-dark fs-5 fw-semibold ">Active Loans Overview</h3>
                    </div>
                    <div className="card-body rounded-2xl p-5 mb-3 mb-sm-0 bg-white">
                        {/* // x---------------------------------x ActiveLoansTable Section // x---------------------------------x  */}
                        <ActiveLoansTable modalValue={setIsOpen} />
                    </div>
                </div>
            </div>

            {/* x---------------------------------x Repay pop up model x---------------------------------x */}
            <div className="relative z-50">
                {/* x---------------------------------x Modal backdrop and content x---------------------------------x */}
                {isOpen && (
                    <div
                        className="fixed px-2 top-0 inset-0 bg-gray-900 bg-opacity-50 flex items-start justify-center transition-opacity duration-300 ease-in-out py-10 overflow-y-scroll"
                        onClick={() => setIsOpen(false)}
                    >
                        <div
                            className={`bg-light1 text-dark py-4 rounded-lg shadow-lg relative w-full max-w-xs sm:max-w-md md:max-w-lg 
                            transform transition-all duration-300 ease-in-out 
                            ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className='modal_header mb-5 border-b pb-4 flex justify-between items-center'>
                                <h1 className='text-lg font-semibold px-6'>Repay</h1>
                                <button
                                    onClick={() => setIsOpen(false)}
                                    className="px-4 py-2 mr-6 rounded"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <form className='px-6'>
                                <div className="mb-4">
                                    <label htmlFor="cardHolderName" className="block text-sm font-medium">
                                        Card Holder's Name
                                    </label>
                                    <input
                                        type="text"
                                        id="cardHolderName"
                                        placeholder="John Doe"
                                        className="bg-light border-[0.5px] hover:border-primary border-gray-00 rounded-lg py-3 px-3 w-full focus:outline-none focus:ring-0 focus:border-dashed"
                                        required
                                    />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="cardNumber" className="block text-sm font-medium">
                                        Card Number
                                    </label>
                                    <input
                                        type="text"
                                        id="cardNumber"
                                        placeholder="1234 5678 9012 3456"
                                        className="bg-light border-[0.5px] hover:border-primary border-gray-00 rounded-lg py-3 px-3 w-full focus:outline-none focus:ring-0 focus:border-dashed"
                                        required
                                    />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="amount" className="block text-sm font-medium">
                                        Amount
                                    </label>
                                    <input
                                        type="text"
                                        id="amount"
                                        placeholder="2000"
                                        className="bg-light border-[0.5px] hover:border-primary border-gray-00 rounded-lg py-3 px-3 w-full focus:outline-none focus:ring-0 focus:border-dashed"
                                        required
                                    />
                                </div>
                                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                                    <div>
                                        <label htmlFor="expiryDate" className="block text-sm font-medium">
                                            Expiry Date
                                        </label>
                                        <input
                                            type="text"
                                            id="expiryDate"
                                            placeholder="MM/YY"
                                            className="bg-light border-[0.5px] hover:border-primary border-gray-00 rounded-lg py-3 px-3 w-full focus:outline-none focus:ring-0 focus:border-dashed"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="cvv" className="block text-sm font-medium">
                                            CVV
                                        </label>
                                        <input
                                            type="text"
                                            id="cvv"
                                            placeholder="123"
                                            className="bg-light border-[0.5px] hover:border-primary border-gray-00 rounded-lg py-3 px-3 w-full focus:outline-none focus:ring-0 focus:border-dashed"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <button type="submit" className='block w-full text-white bg-primary-900 hover:bg-primary-800 rounded py-2'>
                                        Pay Now
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                )}
            </div>
        </div>
    )
}

export default Loans;